$(document).ready(function(){

  //account page validation
  $("#create_customer button").on("click",function(){
    var fname = $("#RegisterForm-FirstName").val().replaceAll(" ","");
    var lname = $("#RegisterForm-LastName").val().replaceAll(" ","");
    var email = $("#RegisterForm-email").val().replaceAll(" ","");
    var psw = $("#RegisterForm-password").val().replaceAll(" ","");

      if(!fname){
        $('#RegisterForm-FirstName').addClass('form-field-error');
        if($('.form-message.message--error ul li.first_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='first_name'>First Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='first_name'>First Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.fname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!lname){
        $('#RegisterForm-LastName').addClass('form-field-error');
        if($('.form-message.message--error ul li.last_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='last_name'>Last Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='last_name'>Last Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.lname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!email){
        $('#RegisterForm-email').addClass('form-field-error');
        if($('.form-message.message--error ul li.email').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='email'>Email can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='email'>Email can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.email');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!psw){
        $('#RegisterForm-password').addClass('form-field-error');
        if($('.form-message.message--error ul li.pass').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='pass'>Password can’t be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='pass'>Password can’t be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.passowrd-eye-show');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }
    else{
      $('#RegisterForm-FirstName,#RegisterForm-LastName,#RegisterForm-email,#RegisterForm-password').removeClass('form-field-error');
        return true;
      }
  });

// add address validation
  $("#add_address").on("click",function(){
    var add_fname_address = $("#AddressFirstNameNew").val().replaceAll(" ","");
    var add_lname_address = $("#AddressLastNameNew").val().replaceAll(" ","");
   if(!add_fname_address){
        $('#AddressFirstNameNew').addClass('form-field-error');
        if($('.form-message.message--error ul li.first_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='first_name'>First Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='first_name'>First Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.faddname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!add_lname_address){
        $('#AddressLastNameNew').addClass('form-field-error');
        if($('.form-message.message--error ul li.last_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='last_name'>Last Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='last_name'>Last Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.laddname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }
     else{
      $('#AddressFirstNameNew,#AddressLastNameNew').removeClass('form-field-error');
        return true;
      }
});
   $( "#address_form_new .field").on( "keypress", function() {
      $(".checkbox-address").show();
    });
  
  // edit address validation
   $("#update_address").on("click",function(){
    var add_fname = $(".fnameadd").val().replaceAll(" ","");
    var add_lname = $(".lnameadd").val().replaceAll(" ","");
   if(!add_fname){
        $('.fnameadd').addClass('form-field-error');
        if($('.form-message.message--error ul li.first_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='first_name'>First Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='first_name'>First Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.fname_add');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!add_lname){
        $('.lnameadd').addClass('form-field-error');
        if($('.form-message.message--error ul li.last_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='last_name'>Last Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='last_name'>Last Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.lname_add');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }
     else{
      $('.fnameadd,.lnameadd').removeClass('form-field-error');
        return true;
      }
});
  $(".edit_address").on("click",function(){
    var check_Daddress = $(this).data("default-address");
    // console.log(check_Daddress);
    if(check_Daddress)
    {
      $(".checkbox_default input[type=checkbox]").prop("checked",true);  
    }
    else
    {
      $(".checkbox_default input[type=checkbox]").prop("checked",false);
    }
    $(".checkbox_default").show();
  });
    

  // contact page js
  $(".contact__button button.button").on("click",function(){
    var Cfname = $("#ContactForm-name").val().replaceAll(" ","");
    var Clname = $("#ContactForm-lname").val().replaceAll(" ","");
    var Cemail = $("#ContactForm-email").val().replaceAll(" ","");
    console.log(Cfname,Clname,Cemail);
    if(!Cfname){
      console.log("in Cfname");
        $('#ContactForm-name').addClass('form-field-error');
        if($('.form-message.message--error ul li.first_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='first_name'>First Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='first_name'>First Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.C_fname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!Clname){
      console.log("in Clname");
        $('#ContactForm-lname').addClass('form-field-error');
        if($('.form-message.message--error ul li.last_name').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='last_name'>Last Name can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='last_name'>Last Name can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.C_lname');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }else if(!Cemail){
      console.log("in emial");
        $('#ContactForm-email').addClass('form-field-error');
        if($('.form-message.message--error ul li.emial').length < 1){
          if($('.form-message.message--error').length > 0){
            var html = "<li class='emial'>Email can't be blank.</li>";
            $(html).insertAfter('.form-message.message--error ul li:last');
          }else{
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='emial'>Email can't be blank.</li></ul></div></div>";
            $(html).insertBefore('.field.field--with-error');
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
      }
    else{
      $('#ContactForm-name,#ContactForm-lname,#ContactForm-email').removeClass('form-field-error');
        return true;
      }
  });

  
    // var first = $('#produkte').offset().top + 700;
    // var second = $('#bestellung-zahlung').offset().top + 300;
    // var third = $('#verpackung-versand').offset().top;
    // var scrollTop = 0;
  
    // $(document).on('scroll',function(){
    //   scrollTop = $(document).scrollTop();
     
    //   if(first > scrollTop){
    //     $('li[acc_title]').removeClass('active');
    //     $('li[acc_title="produkte"]').addClass('active');
    //   }
    //   else if(first < scrollTop && second > scrollTop){
    //     $('li[acc_title]').removeClass('active');
    //     $('li[acc_title="bestellung-zahlung"]').addClass('active');
    //   }
    //   else if(first < scrollTop && second < scrollTop && third > scrollTop){
    //     $('li[acc_title]').removeClass('active');
    //     $('li[acc_title="verpackung-versand"]').addClass('active');
    //   }
      
    // });

  

      $(document).on('scroll',function(){
          var scrollTop = document.querySelector('sticky-header').offsetHeight || 0 ;
        const accTitles_all = document.querySelectorAll('.faq-accordian h2.accordion-heading[acc_heading]') || null;
              if (accTitles_all){
                  accTitles_all.forEach(function(item) {
                   const item_offsets = item.getBoundingClientRect();
                        if((item_offsets.top - 20) < scrollTop){
                          //console.log(item_offsets.top,scrollTop);
                            $('.faq-heading-list .heading-list li[acc_title]').removeClass('active');
                            document.querySelector('[acc_title="'+item.getAttribute('acc_heading')+'"]').classList.add('active');
                        }                          
                  });
              }
      });
  
});